import {z} from 'zod';

export const bulkWorkTypeChangeFormSchema = z.object({
  workTypeId: z.string(),
});

export type BulkWorkTypeChangeFormType = z.infer<typeof bulkWorkTypeChangeFormSchema>;
